// Requirements
import "jquery";

// Components
import { eskadrilaAccordion } from "./components/eskadrila-accordion";
import { updateDetailsOnTabChange } from "./components/flexon-tabs";

// Main scripts
(function ($) {
	"use strict";

	// console.log("Document Loaded");
	// console.log(() => {}); // To test Babel converting ES6 to ES5

	// if ("set" !== Cookies.get("mooveon-cookie-pop")) {
	//   $("body").prepend(_moo_global.cookie_text);
	//   $("#accept-cookie").click(function () {
	//     Cookies.set("mooveon-cookie-pop", "set");
	//     $(".cookie-pop").remove();
	//   });
	// }

	if ("set" == Cookies.get("mooveon-cookie-press")) {
		var $id = $(".wrapper").attr("id");
		var $page = $("#main").children(".row").length + 1;
		// console.log($id);
		// console.log($page);
		if ($id == "press") {
			$("#primary").addClass("loading");

			function mooCallback(result) {
				var _moo = $.parseJSON(result);
				// console.log( _moo );
				if (_moo.data) {
					$("#press-form").hide();
					$("#main").append(_moo.data).children(".row").removeClass("d-hide");
					$("#loadmore").removeClass("d-none");
				} else {
					$("#loadmore").addClass("disabled");
				}
			}

			$.ajax({
				url: _moo_global.ajax_url,
				type: "post",
				data: {
					action: "get_more_press_posts",
					moo_nonce: _moo_global.moo_nonce,
					limit: 9,
					page: $page,
				},
				success: mooCallback,
				complete: function () {
					$("#primary").removeClass("loading");
				},
			});
		}
	}

	jQuery(document).ready(function ($) {
		// Hash
		var hash = window.location.hash;
		if (hash) {
			var offset = -100;
			scrollToTarget(hash, offset);
		}

		// Sticky nav
		var navSticky = true;
		var didScroll;
		var lastScrollTop =
			window.pageYOffset || document.documentElement.scrollTop; // 0;
		var delta = 5;
		var loadOffsets = 300;
		var postsOffset = 0; // Math.round($("#footer").offset().top - $(window).outerHeight()) / 2;
		var datalabOffset = 0; // Math.round($("#footer").offset().top - $(window).outerHeight());
		var postsLoaded = false;
		var laodingDataLabPosts = false;

		// Safely calculate offsets if footer exists
		function updateOffsets() {
			var $footer = $("#footer");
			if ($footer.length) {
				postsOffset =
					Math.round($footer.offset().top - $(window).outerHeight()) / 2;
				datalabOffset = Math.round(
					$footer.offset().top - $(window).outerHeight()
				);
			}
		}

		// Eksadrila Accordion
		eskadrilaAccordion();

		// Update offsets when document is ready
		$(document).ready(function () {
			updateOffsets();
		});

		// Update offsets when window is resized
		$(window).on("resize", function () {
			updateOffsets();
		});

		if ($("#single-blog").length == 0) postsLoaded = true;

		$(window).scroll(function (event) {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll && navSticky) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

		var newURL = "";
		var lastDLPost = 0;
		function hasScrolled() {
			var st = window.pageYOffset || document.documentElement.scrollTop; // $(window).scrollTop();
			var footer = 0;

			// Safely get footer offset
			var $footer = $("#footer");
			if ($footer.length) {
				footer =
					Math.round($footer.offset().top - $(window).outerHeight()) -
					loadOffsets;
			}

			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta) return;

			// InView
			if ($("body").hasClass("single-post")) {
				var currURL = "";
				var urlsArray = [];
				$("article.post:not(.d-none)").each(function () {
					var permalink = $(this).attr("data-permalink");
					if ($(this).isInViewport()) urlsArray.push(permalink);
				});
				// update the URL
				if (window.history.pushState && urlsArray.length) {
					if (st > lastScrollTop) {
						// down
						currURL = urlsArray[urlsArray.length - 1];
					} else {
						// up
						currURL = urlsArray[0];
					}
					if (currURL !== newURL) {
						newURL = currURL;
						window.history.pushState(null, null, newURL);
						// console.log(newURL);
					}
				}
			}

			// If they scrolled down and are past the navbar, add class .show
			if (st > lastScrollTop && st > 120) {
				// Scroll Down
				$(".navbar").removeClass("show");
				if ($(".navbar-collapse").hasClass("show")) {
					$(".navbar-toggler").click();
				}

				// Load DataLab posts
				if (
					$("body").hasClass("page-template-datalab") &&
					!$("[data-posts]").hasClass("done") &&
					st > lastScrollTop &&
					$("[data-posts]>article:last-child").isInViewport()
				) {
					// console.log("triggered");
					laodingDataLabPosts = true;
					// Infinite posts

					var post = $("[data-posts]>article:last-child").attr("id");
					var id = parseInt(post.match(/\d+/)[0]);

					if (lastDLPost != id) {
						lastDLPost = id;
						// console.log(id);
						$("[data-posts]+.loading").addClass("spinner");

						$.ajax({
							url: _moo_global.ajax_url,
							type: "post",
							data: {
								action: "get_datalab_posts",
								moo_nonce: _moo_global.moo_nonce,
								post_id: id,
							},
							success: function (result) {
								var _moo = $.parseJSON(result);
								// console.log(_moo);
								if (_moo.data) {
									$("[data-posts]").append(_moo.data);
								} else {
									$("[data-posts]").addClass("done");
								}
							},
							complete: function () {
								// console.log('done');
								$("[data-posts]+.loading").removeClass("spinner");
								laodingDataLabPosts = false;
							},
						});
					}
				}

				if (
					st > lastScrollTop &&
					st > postsOffset - loadOffsets &&
					!postsLoaded
				) {
					postsLoaded = true;
					// Infinite post
					if ($("body").hasClass("single-post")) {
						var post = $("#main>article:first-child").attr("id");
						var id = parseInt(post.match(/\d+/)[0]);

						post = $("#main>article:last-child").attr("id");
						var ex = parseInt(post.match(/\d+/)[0]);
						// console.log(id);
						$.ajax({
							url: _moo_global.ajax_url,
							type: "post",
							data: {
								action: "get_blog_posts",
								moo_nonce: _moo_global.moo_nonce,
								post_id: id,
								post_ex: ex,
							},
							success: function (result) {
								var _moo = $.parseJSON(result);
								// console.log( _moo );
								$("#main").append(_moo.data);
							},
							complete: function () {
								// console.log('done');
								if (st > lastScrollTop && st > footer) {
									$("#main>.post.d-none:first").removeClass("d-none");
								}
							},
						});
					}
				} else if (st > lastScrollTop && st > footer) {
					$("#main>.post.d-none:first").removeClass("d-none");
				}
			} else {
				// Scroll Up
				if (st + $(window).height() < $(document).height()) {
					$(".navbar").addClass("show");
				}
			}

			lastScrollTop = st;
		}

		// DataLab
		$("#dataLabInfo > a").on("click", function (e) {
			e.preventDefault();
			if ($(this).parent().hasClass("active")) {
				$(this).parent().removeClass("active");
				$(this).siblings(".content").slideUp(400);
			} else {
				$(this).parent().addClass("active");
				$(this).siblings(".content").slideDown(400);
			}
		});
		// $("#dataLabInfo > a").trigger("click");

		$("#press .wpcf7")
			.find('input[type="submit"]')
			.on("click", function (e) {
				var $id = $(".wrapper").attr("id");
				var $pass = $(this).closest(".row").find('input[type="email"]').val();
				var $page = $("#main").children(".row").length;
				var $data = false;
				// console.log($id);
				// console.log($pass);

				if ($id == "press" && $pass) {
					function mooCallback(result) {
						var _moo = $.parseJSON(result);
						// console.log( _moo );
						if (_moo.data) {
							$data = true;
							$("#press-form").hide();
							$("#main")
								.append(_moo.data)
								.children(".row")
								.removeClass("d-hide");
							$("#loadmore").removeClass("d-none");

							if ("set" !== Cookies.get("mooveon-cookie-press")) {
								Cookies.set("mooveon-cookie-press", "set");
							}
						}
					}

					$.ajax({
						url: _moo_global.ajax_url,
						type: "post",
						async: false,
						data: {
							action: "get_press_posts",
							moo_nonce: _moo_global.moo_nonce,
							pass: $pass,
							page: $page,
						},
						success: mooCallback,
						complete: function () {
							// console.log('done');
						},
					});
				}
				// console.log($data);
				if ($data) {
					return false;
				} else {
					return true;
				}
			});

		$(".line-clamp").each(function () {
			var $this = $(this);
			var $last_p = $this.children("p:last-child");
			var $last_p_height = $last_p.outerHeight();
			var $last_p_line_height = parseInt($last_p.css("line-height"));
			var $last_p_lines = $last_p_height / $last_p_line_height;
			var $line_clamp_css_var = parseInt($this.css("--line-clamp"));
			var $toggle = $this.siblings(".line-clamp__toggle");

			// console.log($last_p_lines);
			// console.log($line_clamp_css_var);

			if ($last_p_lines > $line_clamp_css_var) {
				$this.addClass("line-clamp__collapsed");
				$toggle.removeClass("hidden");
			}
		});

		$(".line-clamp__toggle").on("click", function (e) {
			e.preventDefault();
			var $this = $(this);
			var $content = $this.siblings(".content");

			$content.toggleClass("line-clamp__collapsed");
			$this.text(() =>
				!$content.hasClass("line-clamp__collapsed")
					? "Prikaži manje"
					: "Prikaži više"
			);
		});

		$("#loadmore").on("click", function (e) {
			var $id = $(".wrapper").attr("id");
			var $page = $("#main").children(".row").length + 1;
			// console.log($id);
			// console.log($page);
			e.preventDefault();

			if ($id == "press") {
				$("#primary").addClass("loading");

				function mooCallback(result) {
					var _moo = $.parseJSON(result);
					// console.log( _moo );
					if (_moo.data) {
						$("#main").append(_moo.data).children(".row").removeClass("d-hide");
					} else {
						$("#loadmore").addClass("disabled");
					}
				}

				$.ajax({
					url: _moo_global.ajax_url,
					type: "post",
					data: {
						action: "get_more_press_posts",
						moo_nonce: _moo_global.moo_nonce,
						page: $page,
					},
					success: mooCallback,
					complete: function () {
						$("#primary").removeClass("loading");
					},
				});
			}
		});

		// Dropdown Menu
		if (!Modernizr.touch && window.innerWidth >= 1200) {
			$(".navbar-nav .dropdown, .navbar-nav .dropdown-submenu").hover(
				function () {
					$(this).addClass("open").animateNav({ top: 10, fade: "in" });
				},
				function () {
					$(this).removeClass("open").animateNav({ fade: "out" });
				}
			);
		}

		// FAQ
		$(".toggler-all").on("click", function (e) {
			if ($("#sva-pitanja").hasClass("show")) {
				$(this).text(_moo_global.show_all);
			} else {
				$(this).text(_moo_global.close);
			}
		});

		// Overlay search
		$(document).on("click", ".navbar-search", function (e) {
			e.stopPropagation();
			e.preventDefault();

			var $overlay = $(".header-search-overlay");

			if ($overlay.length) {
				$overlay.animateOpacity({
					removeClass: "d-none",
				});
				$($overlay).find(".form-control").focus();
			}
		});
		$("body").on("mousedown", function (e) {
			var target = $(e.target);
			var overlay = ".header-search-overlay";

			if (
				$(overlay).length &&
				!target.is(overlay) &&
				!target.closest(overlay).length
			) {
				$(overlay).animateOpacity({
					fadeTo: 0,
					addClass: "d-none",
				});
			}
		});
		$(document).on(
			"click",
			".header-search-overlay .close-header-search",
			function (e) {
				e.preventDefault();
				var overlay = ".header-search-overlay";
				$(overlay).animateOpacity({
					fadeTo: 0,
					addClass: "d-none",
				});
			}
		);

		// Ponude
		$("#ponude .card-deck")
			.on("init", function (slick) {
				$(this).removeClass("hidden");
			})
			.slick({
				dots: true,
				infinite: false,
				speed: 500,
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				prevArrow:
					'<a class="slick-prev" href="#prev">' +
					'<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>' +
					'<span class="sr-only">Prev</span>' +
					"</a>",
				nextArrow:
					'<a class="slick-next" href="#next">' +
					'<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>' +
					'<span class="sr-only">Next</span>' +
					"</a>",
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 480,
						settings: {
							arrows: false,
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				],
			});

		// Filter
		$("#slick-filter--").slick({
			speed: 6000,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 0,
			cssEase: "linear",
			slidesToShow: 3,
			slidesToScroll: 1,
			pauseOnHover: true,
			variableWidth: true,
			arrows: false,
			buttons: false,
			centerMode: true,
			initialSlide: 1,
		});
		$("#slick-filter--")
			.on("mouseenter", () => {
				$("#slick-filter").slick("slickPause");
			})
			.on("mouseleave", () => {
				$("#slick-filter").slick("slickPlay");
			});

		// Top ponuda - single
		if (false)
			$("#single-top-ponuda #sliderTopPonudaControls").on(
				"slid.bs.carousel",
				function (e) {
					var title = $(e.target)
						.find(".carousel-item.active")
						.attr("data-title");
					var permalink = $(e.target)
						.find(".carousel-item.active")
						.attr("data-permalink");
					if (title !== undefined && permalink !== undefined) {
						window.history.pushState({}, title, permalink);
						document.title = title;
					}
				}
			);

		// Scroll to links
		$(document).on(
			"click",
			'a[href*=\\#]:not([href=\\#]):not(.nav-link):not([class*="toggler"]):not([class*="slick"]):not([id="loadmore"]):not(.carousel-control-prev):not(.carousel-control-next):not(.external)',
			function (e) {
				e.preventDefault();
				var target = $(this).attr("href");
				var offset = 0;
				if ($(this).attr("data-offset") && $(this).attr("data-offset") !== "") {
					offset = $(this).attr("data-offset");
				}
				scrollToTarget(target, offset);
			}
		);
		// Scroll from navbar
		$(document).on(
			"click",
			'#main-menu a[href*="\\#faq"],#footer-menu a[href*="\\#faq"]',
			function (e) {
				if ($("body").hasClass("home")) {
					e.preventDefault();
					var target = "#faq";
					var offset = -30;
					scrollToTarget(target, offset);
				}
			}
		);

		// Video
		$(document).on("click", ".start-video", function () {
			$(this)
				.parent(".controls")
				.siblings(".mp4-video")
				.children(".video")
				.get(0)
				.play();
			$(this)
				.parent(".controls")
				.siblings(".mp4-video")
				.siblings(".banner-image")
				.fadeOut();
			$(this).hide();
			$(this).siblings(".pp-video").show();
		});
		$(document).on("click", ".pause-video", function () {
			$(this)
				.closest(".controls")
				.siblings(".mp4-video")
				.children(".video")
				.get(0)
				.pause();
			$(this).parent(".pp-video").hide().siblings(".start-video").show();
		});
		$(document).on("click", ".stop-video", function () {
			$(this)
				.closest(".controls")
				.siblings(".mp4-video")
				.children(".video")
				.get(0)
				.pause();
			$(this)
				.closest(".controls")
				.siblings(".mp4-video")
				.children(".video")
				.get(0).currentTime = 0;
			$(this)
				.closest(".controls")
				.siblings(".mp4-video")
				.siblings(".banner-image")
				.show();
			$(this).parent(".pp-video").hide().siblings(".start-video").show();
		});
		$(".video").on("pause", function () {
			$(this)
				.parent(".mp4-video")
				.siblings(".controls")
				.children(".pp-video")
				.hide();
			$(this)
				.parent(".mp4-video")
				.siblings(".controls")
				.children(".start-video")
				.fadeIn();
		});
		$(".video").on("ended", function () {
			$(this)
				.parent(".mp4-video")
				.siblings(".controls")
				.children(".pp-video")
				.hide();
			$(this)
				.parent(".mp4-video")
				.siblings(".controls")
				.children(".start-video")
				.fadeIn();
			$(this).parent(".mp4-video").siblings(".banner-image").show();
		});

		// Forma
		/*-*/
		var $wpcf7_max,
			$wpcf7_width,
			$wpcf7_errors,
			$wpcf7_current = 0;
		$(document).on(
			"click",
			".fieldsContainer>.fields>.field>label",
			function (e) {
				var $parent = $(e.target).parent(".field");
				var $next = $parent.next(".field");

				$wpcf7_max = $parent.parent(".fields").children(".field").length;
				$wpcf7_current = $parent.index();

				if (
					$(e.target).siblings("span").children(".form-control").val() === ""
				) {
					$(e.target).siblings("span").children(".form-control").focus();
				} else if ($next.length) {
					$parent.removeClass("show").addClass("hide");
					$next.removeClass("hide").addClass("show");
					var $top = ($wpcf7_current + 1) * -46;
					var $top_counter = ($wpcf7_current + 1) * -18;
					// console.log($top);
					$(".fieldsContainer>.labels>.spans").css({ top: $top });
					$(".fieldsContainer>.counter>.num").css({
						top: $top_counter,
					});

					setTimeout(function () {
						$parent
							.addClass("hide")
							.siblings(".show")
							.children("span")
							.children(".form-control")
							.focus();
					}, 300);

					var $wpcf7_width =
						Math.round((($wpcf7_current + 1) / $wpcf7_max) * 100) + "%";
					$("head").append(
						"<style>.fieldsContainer>.loader>span:before{width:" +
							$wpcf7_width +
							"!important;}</style>"
					);
				} else {
					$("#customForm input[type=submit]").trigger("click");
				}
			}
		);
		/*-*/
		var cformID = $("#customForm").attr("data-id");
		document.addEventListener(
			"wpcf7invalid",
			function (event) {
				// console.log(event.detail);
				if (event.detail.contactFormId == cformID) $wpcf7_errors = 1;
			},
			false
		);
		document.addEventListener(
			"wpcf7submit",
			function (event) {
				// console.log(event.detail);
				if (event.detail.contactFormId == cformID) {
					if (!$wpcf7_errors) {
						$("head").append(
							"<style>.fieldsContainer>.loader>span:before{width:100%!important}</style>"
						);
						$(".fieldsContainer>.fields, .fieldsContainer>.labels").hide();
						$(".wpcf7-response-output").addClass("show");
					} else {
						$("head").append(
							"<style>.fieldsContainer>.loader>span:before{width:" +
								$wpcf7_width +
								"!important;}</style>"
						);
						$wpcf7_errors = 0;
					}
				}
			},
			false
		);
		/*-*/

		// Wizard
		var $wpcf7_wizard_errors,
			$wpcf7_wizard_empty = 0,
			$wpcf7_wizard_current = 0;
		$(document).on(
			"click",
			"#wizard .form-group>.prev,#wizard .form-group>.next",
			function (e) {
				e.preventDefault();

				var $parent = $(".step.active");
				var $next = $parent.next(".step");

				$wpcf7_wizard_current = $parent.index();

				if ($(e.target).hasClass("prev")) {
					// console.log('prev');
					$next = $parent.prev(".step");
					$wpcf7_wizard_current--;
				} else {
					$wpcf7_wizard_current++;
				}

				if (!$(e.target).hasClass("prev"))
					$parent.children(".form-group").each(function (i, elem) {
						// console.log($(elem).find('input').val());
						if (
							($(elem).find("input").val() === "" ||
								$(elem).find("textarea").val() === "" ||
								$(elem).find("select").val() === "") &&
							!$wpcf7_wizard_empty
						) {
							// console.log($(elem).index());
							$wpcf7_wizard_empty = $(elem).index();
							$wpcf7_wizard_empty++;
						}
					});
				// console.log($wpcf7_wizard_empty);
				// if($(e.target).parent().siblings('.form-group').find('input').val() === "") {
				if ($wpcf7_wizard_empty && !$(e.target).hasClass("prev")) {
					$parent
						.children(".form-group:nth-child(" + $wpcf7_wizard_empty + ")")
						.find("input,textarea,select")
						.focus();
					$wpcf7_wizard_empty = 0;
				} else if ($next.length) {
					$parent.removeClass("active");
					$next.addClass("active");
					// $('#steps').hide();
					$("#steps>li").removeClass("active");
					$("#steps>li:nth-child(" + $wpcf7_wizard_current + ")").addClass(
						"active"
					);

					setTimeout(function () {
						$next
							.children(".form-group:first-child")
							.find("input,textarea,select")
							.focus();
					}, 300);
				} else {
					$("#wizard").parent("form").submit();
				}
			}
		);
		$(document).on("click", "#steps .tip", function (e) {
			e.preventDefault();
			var ind = $(e.target).attr("data-tip");

			$("#steps>li").removeClass("active");
			$("#wizard>.step").removeClass("active");

			$("#steps>li:nth-child(" + ind + ")").addClass("active");
			$('#wizard>section[data-step="' + ind + '"]').addClass("active");
		});
		var wform = $("#wizard").closest(".wpcf7").attr("id");
		if (wform) {
			var wformsplit = wform.split("-");
			var wformID = wformsplit[1].match(/\d+/)[0];
			// console.log(wformID);
			document.addEventListener(
				"wpcf7invalid",
				function (event) {
					// console.log(event.detail.contactFormId);
					if (event.detail.contactFormId == wformID) $wpcf7_wizard_errors = 1;
				},
				false
			);
			document.addEventListener(
				"wpcf7submit",
				function (event) {
					// console.log(event.detail);
					if (event.detail.contactFormId == wformID) {
						if (!$wpcf7_wizard_errors) {
							$(".step.active").removeClass("active");
						} else {
							$wpcf7_wizard_errors = 0;
						}
					}
				},
				false
			);
		}

		// FlexOn Tabs
		updateDetailsOnTabChange();

		// FlexOn Popup
		$(".flexon-popup-toggle").on("click", function (e) {
			e.preventDefault();
			var $this = $(this);
			var $popup = $($this.attr("data-popup"));

			// close all popups
			$("[id*=flexon-popup]").removeClass("show");

			// is close button
			if ($this.hasClass("close")) {
				$popup.removeClass("show");
				return;
			}

			// open popup
			if ($popup.length) {
				$popup.addClass("show");
			}
		});

		// Tabs
		if ($("#topPonudaForm").length && $("#topTab").length) {
			var currentTab = $("#topTab").find(".active").closest("li").index() + 1;
			var detailsInput = $('#topPonudaForm .wpcf7 input[name="details"]');

			var period = $("#topTab>li:nth-child(" + currentTab + ")>a").text();
			var kilometers = $(
				"#topTabContent>.tab-pane:nth-child(" +
					currentTab +
					")>p:first-child>em"
			).text();

			var detailsData =
				"Trajanje: " + period + ", kilometraža: " + kilometers + "km";
			detailsInput.val(detailsData);

			$('#topTab a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
				var current = $(e.target); // newly activated tab
				var previous = $(e.relatedTarget); // previous active tab

				// console.log(current.closest("li").index());
				currentTab = current.closest("li").index() + 1;

				period = $("#topTab>li:nth-child(" + currentTab + ")>a").text();
				kilometers = $(
					"#topTabContent>.tab-pane:nth-child(" +
						currentTab +
						")>p:first-child>em"
				).text();
				detailsData =
					"Trajanje: " + period + ", kilometraža: " + kilometers + "km";

				detailsInput.val(detailsData);
			});
		}

		// Disabled links
		$(document).on("click", "a.disabled", function (e) {
			e.preventDefault();
			return false;
		});

		// Show/hide back to top
		$(window).bind("scroll", function (e) {
			if ($(window).scrollTop() > 123)
				$(".scrollTop").animateOpacity({
					removeClass: "d-none",
				});
			else if (!$(".scrollTop").hasClass("d-none"))
				$(".scrollTop").animateOpacity({
					fadeTo: 0,
					addClass: "d-none",
				});
		});

		// simpleLightbox
		var lb_options = {
			captionsData: "alt",
			loop: false,
		};
		var lightbox = $(".wp-block-gallery").each(function () {
			$(this).find("a").simpleLightbox(lb_options);
		});

		// Filter - Top Ponuda 2021
		$("#tp21-filters :input").on("change", function (evt) {
			var filters = {}; // key/value per group
			var params = {};

			if ($("#tp21-filters select").length) {
				$(":selected").each(function () {
					var group = $(this).data("id"); // <-- something that identifies the group
					if (group !== undefined) {
						filters[group] = (filters[group] || []).concat("." + this.value);
						params[group] = (params[group] || []).concat("" + this.value);
					}
				});
			}
			$(":input:checked").each(function () {
				var group = $(this).data("id"); // <-- something that identifies the group
				if (group !== undefined) {
					filters[group] = (filters[group] || []).concat("." + this.value);
					params[group] = (params[group] || []).concat("" + this.value);
				}
			});
			// console.log(filters);

			var $filtered = $("#main .col-md-4").removeClass("is-active");
			// Apply each filter on the result of the previous one:
			for (var group in filters) {
				$filtered = $filtered.filter(filters[group].join(","));
			}
			// console.log($filtered);
			$filtered.each(function () {
				$(this).css({ opacity: 0 }).addClass("is-active");
				window.requestAnimationFrame(() => {
					$(this).css({ opacity: 1 });
				});
			});

			// Show/hide no results placeholder
			updateNoResultsPlaceholder();

			// URL params
			const currentURL = new URL(window.location.href);
			updateURLParams(currentURL, params);
		});

		if ($("#tp21-filters").length) {
			// URL params
			const currentURL = new URL(window.location.href);
			const paramsObject = createUrlParamsObject(currentURL);
			// console.log(paramsObject);
			var $filtered = $("#main .col-md-4").removeClass("is-active");
			var filters = {}; // key/value per group

			for (let key in paramsObject) {
				if (paramsObject.hasOwnProperty(key) && key !== "undefined") {
					const values = paramsObject[key];

					if (Array.isArray(values)) {
						values.forEach((value) => {
							const inputValue = "filter-" + key + "-" + value;
							// console.log(inputValue);
							$("select").each(function () {
								if (this.id === key) {
									$(this).val(inputValue);
									// console.log(inputValue);
									filters[$(this).attr("data-id")] = (
										filters[$(this).attr("data-id")] || []
									).concat("." + this.value);
								}
								// console.log(this.value);
							});
							$(":input").each(function () {
								if (this.id === value && this.value === inputValue) {
									$(this).prop("checked", true);
									// console.log(inputValue);
									filters[$(this).attr("data-id")] = (
										filters[$(this).attr("data-id")] || []
									).concat("." + this.value);
								}
								// console.log(this.id);
							});
						});
					}
				}
			}
			// console.log(filters);

			// Apply each filter on the result of the previous one:
			for (var group in filters) {
				$filtered = $filtered.filter(filters[group].join(","));
			}
			// console.log($filtered);
			$filtered.each(function () {
				$(this).css({ opacity: 0 }).addClass("is-active");
				window.requestAnimationFrame(() => {
					$(this).css({ opacity: 1 });
				});
			});

			// Show/hide no results placeholder
			updateNoResultsPlaceholder();
		}

		// Initialize no results placeholder on page load
		if ($("#tp21-filters").length) {
			updateNoResultsPlaceholder();
		}
	});

	function createUrlParamsObject(url) {
		const urlParams = new URLSearchParams(url.search);
		const paramsObject = {};

		urlParams.forEach((value, key) => {
			if (!paramsObject.hasOwnProperty(key)) {
				paramsObject[key] = value.split(",");
			}
		});

		return paramsObject;
	}

	function updateURLParams(url, obj) {
		let params = [];
		const urlParams = new URLSearchParams(url.search);

		// Remove existing parameters not present in the object
		urlParams.forEach((value, key) => {
			if (!obj.hasOwnProperty(key)) {
				urlParams.delete(key);
			}
		});

		for (let key in obj) {
			if (obj.hasOwnProperty(key) && key !== "undefined") {
				const values = obj[key];
				let valString = [];

				if (Array.isArray(values)) {
					values.forEach((value) => {
						const strippedValue = value.replace("filter-" + key + "-", "");
						valString.push(strippedValue);
					});
					urlParams.set(key, valString.join());
				}
			}
		}

		urlParams.forEach((value, key) => {
			params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
		});

		url.search = urlParams.toString();
		window.history.pushState(null, null, url);
		// console.log(params);
	}

	// Fade animation
	$.fn.extend({
		animateNav: function (settings) {
			var options = $.extend(
				{
					child: ".dropdown-menu",
					delay: 100,
					top: 0,
					fade: "in",
					duration: 200,
				},
				settings
			);
			if (options.fade == "in") {
				if ($(this).hasClass("dropdown-submenu"))
					$(this)
						.children()
						.siblings(options.child)
						.stop()
						.css({
							display: "block",
							top: 0 + options.top + "%",
							opacity: 0,
						})
						.delay(options.delay)
						.animate(
							{
								top: "0",
								opacity: 1,
							},
							options.duration
						);
				else
					$(this)
						.children()
						.siblings(options.child)
						.stop()
						.css({
							display: "block",
							top: 100 + options.top + "%",
							opacity: 0,
						})
						.delay(options.delay)
						.animate(
							{
								top: "100%",
								opacity: 1,
							},
							options.duration
						);
			} else
				$(this)
					.children()
					.siblings(options.child)
					.stop()
					//.delay(options.delay)
					.fadeOut(options.duration);
		},
	});
	// Opacity animation
	$.fn.extend({
		animateOpacity: function (settings) {
			var options = $.extend(
				{
					fadeTo: 1,
					duration: 300,
					easing: "swing",
					removeClass: "",
					addClass: "",
				},
				settings
			);
			$(this)
				.stop()
				.removeClass(options.removeClass)
				.fadeTo(options.duration, options.fadeTo, function () {
					if (!options.fadeTo) $(this).addClass(options.addClass);
				});
		},
	});

	$.fn.isInViewport = function () {
		var offset = 200;
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		return (
			elementBottom - offset > viewportTop &&
			elementTop + offset < viewportBottom
		);
	};

	function isElementInViewport(el) {
		//special bonus for those using jQuery
		if (typeof jQuery === "function" && el instanceof jQuery) {
			el = el[0];
		}
		var rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight ||
					document.documentElement.clientHeight) /*or $(window).height() */ &&
			rect.right <=
				(window.innerWidth ||
					document.documentElement.clientWidth) /*or $(window).width() */
		);
	}

	// Scroll to function
	function scrollToTarget(e, offset) {
		$("html, body")
			.stop()
			.animate(
				{
					scrollTop: $(e).offset().top + parseInt(offset),
				},
				600,
				"swing"
			);
		return false;
	}

	// Update no results placeholder visibility
	function updateNoResultsPlaceholder() {
		var $visibleCards = $("#main .col-md-4.is-active");
		var $placeholder = $("#no-results-placeholder");

		if ($visibleCards.length === 0) {
			$placeholder.show();
		} else {
			$placeholder.hide();
		}
	}

	// Clear all filters function
	window.clearAllFilters = function () {
		// Uncheck all checkboxes
		$("#tp21-filters input[type='checkbox']").prop("checked", false);

		// Reset all radio buttons to "All"
		$("#tp21-filters input[type='radio']").prop("checked", false);
		$("#tp21-filters input[type='radio'][value*='-all']").prop("checked", true);

		// Reset all selects to "All"
		$("#tp21-filters select").each(function () {
			$(this).find('option[value*="-all"]').prop("selected", true);
		});

		// Clear URL parameters
		const currentURL = new URL(window.location.href);
		const urlParams = new URLSearchParams(currentURL.search);

		// Get all filter group names from the filter inputs
		var filterGroups = [];
		$("#tp21-filters :input").each(function () {
			var group = $(this).data("id");
			if (group && filterGroups.indexOf(group) === -1) {
				filterGroups.push(group);
			}
		});

		// Remove all filter-related parameters
		filterGroups.forEach(function (group) {
			urlParams.delete(group);
		});

		// Trigger change event to update filters
		$("#tp21-filters :input").first().trigger("change");

		// Update the URL without page reload
		const newURL =
			currentURL.pathname +
			(urlParams.toString() ? "?" + urlParams.toString() : "");
		window.history.replaceState({}, "", newURL);
	};
})(jQuery);
